@if (isMobile()) {
    <app-mobile-dashboard
        [loading]="loading"
        [report]="report"
        [company]="company"
        [accordionState]="accordionState"
        (handleChangePeriod)="onChangePeriod($event)"
        (handleChangeComparation)="onChangeComparation($event)"
        (handleResetPeriod)="onResetPeriod()"
        [previewMode]="previewMode"
        (handleChangeAnalysis)="onChangeAnalysis($event)"
        (handleResetAnalysis)="onResetAnalysis()"
    ></app-mobile-dashboard>
} @else {
    <app-desktop-dashboard
        [loading]="loading"
        [accordionState]="accordionState"
        [report]="report"
        [company]="company"
        (handleChangePeriod)="onChangePeriod($event)"
        (handleChangeComparation)="onChangeComparation($event)"
        (handleResetPeriod)="onResetPeriod()"
        [previewMode]="previewMode"
        (handleChangeBudget)="onChangeBudget($event)"
        (handleResetBudget)="onResetBudget()"
        (handleChangeProjection)="onChangeProjection($event)"
        (handleResetProjection)="onResetProjection()"
        (handleChangeGoals)="onChangeGoals()"
        (handleResetGoals)="onResetGoals()"
    ></app-desktop-dashboard>
}
